import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './BindingPage.module.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import statusFailSvg from '../../assets/status-fail.svg';

export default function BindingFail() {
  const navigate = useNavigate();

  const handleRebind = () => {
    navigate('/hotai/login');
  };

  return (
    <div className="center-viewport">
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer'}} />
          </Link>
        </div>
          <div className={styles['center-card']}>
            <img src={statusFailSvg} alt="綁定失敗" className={styles['status-icon']} />
            <div className={styles['status-title']}>綁定失敗</div>
            <div className={styles['status-desc']}>您的資料有誤，請再次確認</div>
            <button 
              className={styles['status-btn'] + ' ' + styles['status-btn-red']}
              onClick={handleRebind}
            >
              重新綁定
            </button>
          </div>
    </div>
  );
} 